var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',_vm._l((_vm.data),function(metric,id){return _c('tr',{key:id},_vm._l((metric),function(value,id){return _c('td',{key:id,class:[id == 0 ? 'highlighted bold yellow' : '']},[_vm._v(_vm._s(value))])}),0)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }